import { RouterProvider as UIRouterProvider } from '@sixfold/common-ui';
import * as React from 'react';
import { matchPath, useNavigate, useLocation } from 'react-router';

type RouterProviderProps = {
  children: React.ReactNode;
};

export const RouterProvider = ({ children }: RouterProviderProps) => {
  const navigate = useNavigate();
  const { pathname: locationPathname } = useLocation();

  const getCurrentPropValue = React.useCallback(
    (href: string) => {
      // Discard query string and hash from href for matching.
      const hrefPathname = new URL(href, window.location.origin).pathname;

      // If the match is exact, then the current route is the current page.
      const exactMatch = matchPath({ path: hrefPathname, end: true }, locationPathname);
      if (exactMatch !== null) {
        return 'page';
      }

      // Check if it's a parent/prefix match.
      const partialMatch = matchPath({ path: hrefPathname, end: false }, locationPathname);
      if (partialMatch !== null) {
        return true;
      }

      // No match.
      return undefined;
    },
    [locationPathname],
  );

  return (
    <UIRouterProvider navigate={navigate} getCurrentPropValue={getCurrentPropValue}>
      {children}
    </UIRouterProvider>
  );
};
